import { Img } from "wmk-image";
import { BlockIconButtonsRowFields } from "../fragments/blockIconButtonsRowFields";
import { IconCopyButtonFields } from "../fragments/iconCopyButtonFields";

export class IconButtonsRow {
  title: string;
  headline?: string;
  subtitle?: string;
  buttons: IconCopyButtonClassInt[];
  constructor(_node: BlockIconButtonsRowFields) {
    // console.log('_node: ', _node);
    const node = { ..._node };
    // console.log('node: ', node);
    this.title = node.title;
    this.headline = node.headline;
    this.subtitle = node.subtitle ? node.subtitle : null;
    this.buttons = node.buttons?.map((button) => new IconCopyButton(button));
  }
}

interface IconCopyButtonClassInt {
  title: string;
  icon: Img;
  buttonCopy?: string;
  link: string;
}

export class IconCopyButton {
  title: string;
  icon: Img;
  buttonCopy?: string;
  link: string;
  constructor(node: IconCopyButtonFields) {
    this.title = node.title;
    this.icon = new Img(node.icon);
    this.buttonCopy = node.buttonCopy ? node.buttonCopy : null;
    const linkType = node.linksTo.__typename;
    let link = "";
    switch (linkType) {
      case "ContentfulWmkPages":
        link = `/${node.linksTo.slug}`;
        break;
      case "ContentfulWmkBlogs":
        link = `/blog/${node.linksTo.slug}`;
        break;
      case "ContentfulWmkSolutions":
        link = node.isServiceLink === "True" ? `/services/${node.linksTo.slug}` : `/solutions/${node.linksTo.slug}`;
        break;
      case "ContentfulLinksExternal":
        link = node.linksTo.url;
        break;
      case "ContentfulWorkCaseStudyOld":
      default:
        break;
    }
    this.link = link;
  }
}
